/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  Center,
  Button as ChakraButton,
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { IoClose } from 'react-icons/io5';
import { LuMoveRight } from 'react-icons/lu';
import { FaDownload } from 'react-icons/fa';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { useOpenMagazine } from '../../contexts/MagazineContext';

const monthNames = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export function MagazineModal() {
  const { magazine, closeMagazine } = useOpenMagazine();
  const { colors } = useTheme();

  if (!magazine) return null;

  const cover = magazine.cover || magazine.image;
  const title = magazine.articleTitle || magazine.articleContent || magazine.title || magazine.name || magazine.agreement || '';
  const fileUrl = magazine.fileUrl || magazine.pdf || magazine.file || magazine.link;
  const issn = magazine.issn || magazine.isbn;

  const handleRead = () => {
    if (!fileUrl) return;
    closeMagazine();
    window.open(fileUrl, '_blank');
  };

  const handleDownload = async () => {
    if (!fileUrl) return;
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${title || 'revista'}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      window.open(fileUrl, '_blank');
    }
  };

  return (
    <Modal isCentered size={{ sm: 'sm', md: 'lg' }} isOpen={magazine != null} onClose={closeMagazine}>
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent borderRadius="20px">
        <ModalBody position="relative">
          <Center
            position="absolute"
            top="10px"
            right="10px"
            cursor="pointer"
            onClick={closeMagazine}
            zIndex={1}
            w="32px"
            h="32px"
            borderRadius="full"
            bg="gray.100"
            _hover={{ bg: 'gray.200' }}
          >
            <IoClose size={20} color="#555" />
          </Center>

          <VStack spacing={3} paddingTop="20px" paddingBottom="8px">
            <Image
              w="40%"
              aspectRatio={0.7}
              objectFit="cover"
              src={cover}
              borderRadius="8px"
              boxShadow="rgba(100, 100, 111, 0.3) 0px 7px 15px 0px"
            />

            <VStack spacing={0}>
              <SectionTitle color="black" textAlign="center" fontSize="16px">
                {title}
              </SectionTitle>
              {magazine.referenceMonth && magazine.referenceYear && (
                <Text fontSize="13px" color="#a9a9a9">
                  {monthNames[(magazine.referenceMonth || 1) - 1]} {magazine.referenceYear}
                </Text>
              )}
              {magazine.issueNumber && (
                <Text fontSize="13px" color="#a9a9a9">
                  Edição nº {magazine.issueNumber}
                </Text>
              )}
              {issn && (
                <Text fontSize="13px" color="#a9a9a9">
                  ISSN: {issn}
                </Text>
              )}
            </VStack>

            {magazine.articleContent && (
              <VStack w="100%" align="stretch" spacing={1}>
                <Text fontSize="12px" fontWeight="600" color="#555">
                  Sinopse
                </Text>
                <Box
                  width="100%"
                  fontSize="14px"
                  lineHeight="1.55"
                  maxH="200px"
                  overflowY="auto"
                  pr={1}
                  sx={{
                    '& p': { marginBottom: '0.5em' },
                    '& ul, & ol': { paddingLeft: '1.2em' },
                  }}
                  dangerouslySetInnerHTML={{ __html: magazine.articleContent }}
                />
              </VStack>
            )}

            <VStack w="100%" spacing={2}>
              <ChakraButton
                width="100%"
                borderRadius="100px"
                color="white"
                _hover={{ backgroundColor: colors.primaryColor }}
                padding="20px 0px"
                border={`2px solid ${colors.primaryColor}`}
                backgroundColor={colors.primaryColor}
                onClick={handleRead}
                rightIcon={<LuMoveRight />}
                fontSize="14px"
                fontWeight="600"
              >
                Ler Agora
              </ChakraButton>

              <ChakraButton
                width="100%"
                borderRadius="100px"
                padding="16px 0px"
                backgroundColor="white"
                border={`2px solid ${colors.primaryColor}`}
                color={colors.primaryColor}
                _hover={{ backgroundColor: `${colors.primaryColor}10` }}
                onClick={handleDownload}
                leftIcon={<FaDownload fontSize="12px" />}
                fontSize="13px"
              >
                Baixar (Download)
              </ChakraButton>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
